import type { EnvironmentConfig } from '@luna/env';
import { getEnv } from '@luna/env';

export const COUNTRY_URL_PARAM = 'country';
const BROWSER_STACK_LOCALHOST_HOSTNAME = 'bs-local.com';

export function isProdEnvironment(): boolean {
    const { environment } = getEnv<EnvironmentConfig>();
    return ['prod', 'prodnew'].includes(environment);
}

export function isUatEnvironment(): boolean {
    const { environment } = getEnv<EnvironmentConfig>();
    return environment === 'uat';
}

export function isFatEnvironment(): boolean {
    const { environment } = getEnv<EnvironmentConfig>();
    return ['fat', 'fat2'].includes(environment);
}

export function isLocalEnvironment(): boolean {
    const { environment } = getEnv<EnvironmentConfig>();
    return environment === 'localDev';
}

export function isBrowserStackLocalEnvironment(hostname: string): boolean {
    return isLocalEnvironment() && hostname === BROWSER_STACK_LOCALHOST_HOSTNAME;
}

export function isCypressEnvironment(): boolean {
    return 'Cypress' in window;
}

export function isDevEnvironment(hostname: string): boolean {
    const developmentUrlSuffix = '.dev.beeone.at';
    return hostname.endsWith(developmentUrlSuffix);
}

export function isFeatureBranch(hostname: string): boolean {
    const featureBranchRegex = /-\w{2}\.dev\.beeone\.at$/;
    return featureBranchRegex.test(hostname);
}
